export default "__VITE_ASSET__DhBfgFHe__"